module.exports = __webpack_public_path__ + "img/Electric.a736568e.svg";